/**
 * @file StatisticConst.js
 * @desc 统计日志埋点静态文件
 * @author liuyanan06
 * @data 2021/05/25
 */
// import statisticAction from '@/common/utils/statisticAction';
import statisticAction from '@/pages/pano-game/helper/statisticAction';
import {getParamsFromUrl} from '@baidu/map-fe-utils';
const statisticConst = {};
const sendBaiduStatistics = statisticAction.sendBaiduStatistics;
const sendStatisticalInfo = statisticAction.submitStatisticalInfo;
const baiduKey = 'cjh.panoGame';
const {fr = 'default', cuid = ''} = getParamsFromUrl();

// 活动主页展现来源
statisticConst.homeShow = () => {
    sendBaiduStatistics('homeShow', 'from', fr);
    sendStatisticalInfo(baiduKey + '.home.show', {fr});
};

statisticConst.dyyTj = is_Login => {
    sendStatisticalInfo(baiduKey + '.homedyy.show', {
        fr,
        cuid,
        is_Login: is_Login.toString()
    });
};
// 题目页展现
statisticConst.questionShow = (type, level = 0) => {
    sendBaiduStatistics('questionShow', 'from', fr);
    sendStatisticalInfo(baiduKey + '.question.show', {
        type,
        level,
        fr
    });
};

// 单题展现
statisticConst.singleQuestionShow = (type, number = 0) => {
    sendBaiduStatistics('singleQuestion', 'show', fr);
    sendStatisticalInfo(baiduKey + '.singleQuestion.show', {
        number,
        type,
        fr
    });
};
// 单题回答正确
statisticConst.singleQuestionRight = (type, number = 0) => {
    sendBaiduStatistics('singleQuestion', 'right', fr);
    sendStatisticalInfo(baiduKey + '.singleQuestion.right', {
        number,
        type,
        fr
    });
};

// 首页大逃杀按钮点击
statisticConst.escapeMainBtnClick = () => {
    sendBaiduStatistics('escapeMainBtn', 'click');
    sendStatisticalInfo(baiduKey + '.escapeMainBtn.click', {
        fr
    });
};
// 首页闯关按钮点击
statisticConst.kingRoadBtnClick = () => {
    sendBaiduStatistics('kingRoadBtn', 'click');
    sendStatisticalInfo(baiduKey + '.kingRoadBtn.click', {
        fr
    });
};
// 大逃杀首页展现
statisticConst.escapePageShow = () => {
    sendBaiduStatistics('escapePage', 'show');
    sendStatisticalInfo(baiduKey + '.escapePage.show', {
        fr
    });
};
// 闯关首页展现
statisticConst.kingRoadPageShow = () => {
    sendBaiduStatistics('kingRoadPage', 'show');
    sendStatisticalInfo(baiduKey + '.kingRoadPage.show', {
        fr
    });
};
// 进入模式次数
statisticConst.playGame = (type, level = 0) => {
    sendBaiduStatistics('playGame', type);
    sendStatisticalInfo(baiduKey + '.playGame', {
        type,
        level,
        fr
    });
};
// 进入答题正确次数
statisticConst.playGameSuccess = type => {
    sendBaiduStatistics('playGameSuccess', type);
    sendStatisticalInfo(baiduKey + '.playGameSuccess', {
        type,
        fr
    });
};

// 进入模式通关页次数
statisticConst.playGamePass = (type, success = 1, level = 0) => {
    sendBaiduStatistics('playGamePass', type);
    sendStatisticalInfo(baiduKey + '.playGamePass', {
        success,
        type,
        level,
        fr
    });
};

// 复活弹窗展现
statisticConst.reBackDiaShow = type => {
    sendBaiduStatistics('reBackDiaShow', type);
    sendStatisticalInfo(baiduKey + '.reBackDiaShow', {
        type,
        fr
    });
};

// 复活方式
statisticConst.playGameBack = (type, backType, isSucc, level = 0) => {
    sendBaiduStatistics('playGameBack', type, backType, isSucc);
    sendStatisticalInfo(baiduKey + '.playGameBack', {
        type, // ordinary master
        backType, // free coins assist
        isSucc, // 1成功  2失败
        level,
        fr
    });
};

// 度口令回端
statisticConst.duWordHelp = () => {
    sendBaiduStatistics('duWordHelp', 'show');
    sendStatisticalInfo(baiduKey + '.duWordHelp');
};

// 页面分享
statisticConst.shareActivity = (type, mode) => {
    sendBaiduStatistics('shareActivity', type);
    sendStatisticalInfo(baiduKey + '.shareActivity', {
        type, // mainPage  ansRight duWord poster
        mode,
        fr
    });
};

// 端外展示页面
statisticConst.outNative = type => {
    sendBaiduStatistics('outNative', type);
    sendStatisticalInfo(baiduKey + '.outNative', {
        type, // mainPage
        fr
    });
};

// 端外展示页面
statisticConst.shuidiClick = () => {
    sendBaiduStatistics('shuidiClick', 'click');
    sendStatisticalInfo(baiduKey + '.shuidiClick', {
        fr
    });
};

// 新用户
statisticConst.newUser = () => {
    sendBaiduStatistics('newUser', 'show');
    sendStatisticalInfo(baiduKey + '.newUser', {
        fr
    });
};

// 端外调起客户端
statisticConst.outNativeBackNative = type => {
    sendBaiduStatistics('outNativeBackNative', type);
    sendStatisticalInfo(baiduKey + '.outNativeBackNative', {
        type, // mainPage
        fr
    });
};

// 福利商城页展示
statisticConst.welfareShow = () => {
    sendBaiduStatistics('welfareShow', 'from', fr);
    sendStatisticalInfo(baiduKey + '.welfare.show', {fr});
};

// 福利商城页抽奖按钮点击
statisticConst.lotteryClick = () => {
    sendBaiduStatistics('lotteryClick', 'click');
    sendStatisticalInfo(baiduKey + '.lotteryClick', {
        fr
    });
};

// 福利商城页任务列表-点击完成任务
statisticConst.taskComplete = type => {
    sendBaiduStatistics('taskComplete', type);
    sendStatisticalInfo(baiduKey + '.taskComplete', {
        type,
        fr
    });
};

statisticConst.cashCenterBtnClick = () => {
    sendBaiduStatistics('cashCenterBtnClick', 'from', fr);
    sendStatisticalInfo(baiduKey + '.cashCenterBtnClick', {fr});
};

// 福利商城页任务列表-点击领取金币
statisticConst.getCoins = type => {
    sendBaiduStatistics('getCoins', type);
    sendStatisticalInfo(baiduKey + '.getCoins', {
        type,
        fr
    });
};

// 错题本页展示
statisticConst.noteShow = () => {
    sendBaiduStatistics('noteShow', 'from', fr);
    sendStatisticalInfo(baiduKey + '.note.show', {fr});
};

// 错题本页点击查看全景
statisticConst.goPano = () => {
    sendBaiduStatistics('goPano', 'click');
    sendStatisticalInfo(baiduKey + '.goPano', {
        fr
    });
};

export default statisticConst;
